import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import actions from 'actions'
import Timeline from 'components/Timeline/Timeline'
import Processing from 'components/Processing/Processing'
import { Container, Dimmer, Loader } from 'semantic-ui-react'
import { gzip } from 'pako'
import { isChaptersMode } from 'utils/functions'

class TimelineContainer extends Component {
  constructor () {
    super(...arguments)

    this.onProcessing = this.onProcessing.bind(this)
  }

  async onProcessing (meta, isValid, isMoveEventsTask) {
    const {
      updateEvents,
      moveEvents,
      transcodeWebinar,
      setNotificationStatus,
      settings: { mediaParams }
    } = this.props

    if (!isValid) {
      setNotificationStatus({ notificationStatus: 'badMeta' })
      return false
    }

    const compressedMeta = gzip(JSON.stringify(meta))

    setNotificationStatus({ notificationStatus: 'progress' })

    try {
      await updateEvents({
        meta: compressedMeta,
        mediaId: mediaParams.mediaId
      })

      try {
        if (isMoveEventsTask) {
          await moveEvents({
            ...mediaParams
          })
        } else {
          await transcodeWebinar({
            ...mediaParams
          })
        }

        setNotificationStatus({ notificationStatus: 'isProcessing' })
      } catch (err) {
        if (!err) setNotificationStatus({ notificationStatus: 'networkError' })
      }
    } catch (err) {
      if (!err) setNotificationStatus({ notificationStatus: 'networkError' })
    }
  }

  render () {
    const {
      addItem,
      updateItem,
      removeItem,
      setActiveItem,
      media: {
        meta,
        timeline,
        notificationStatus
      }
    } = this.props
    const { isPlayerLoaded, playerElement } = this.props.media.player

    return (
      <Container fluid>
        { isPlayerLoaded
          ? <div>
            { !isChaptersMode() &&
              <Timeline
                {...meta}
                {...timeline}
                playerElement={playerElement}
                addItem={addItem}
                updateItem={updateItem}
                removeItem={removeItem}
                setActiveItem={setActiveItem}
              />
            }
            <Processing
              editData={meta.editData}
              onProcessing={this.onProcessing}
              notificationStatus={notificationStatus}
            />
          </div>
          : <Dimmer active>
            <Loader size='large'>Загрузка медиа данных...</Loader>
          </Dimmer>
        }
      </Container>
    )
  }
}

const {
  bool,
  object,
  func
} = PropTypes

TimelineContainer.propTypes = {
  isPlayerLoaded: bool,
  playerElement: object,
  settings: object.isRequired,
  media: object.isRequired,
  updateEvents: func.isRequired,
  moveEvents: func.isRequired,
  transcodeWebinar: func.isRequired,
  setNotificationStatus: func.isRequired,
  addItem: func.isRequired,
  updateItem: func.isRequired,
  removeItem: func.isRequired,
  setActiveItem: func.isRequired
}

export default connect((state) => {
  return {
    settings: state.settings,
    media: state.media
  }
}, {
  updateEvents: actions.media.updateEvents,
  moveEvents: actions.media.moveEvents,
  transcodeWebinar: actions.media.transcodeWebinar,
  setNotificationStatus: actions.media.setNotificationStatus,
  addItem: actions.media.addItem,
  updateItem: actions.media.updateItem,
  removeItem: actions.media.removeItem,
  setActiveItem: actions.media.setActiveItem
})(TimelineContainer)



// WEBPACK FOOTER //
// ./src/containers/TimelineContainer/TimelineContainer.js